import script from "./upgrade-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./upgrade-table.vue?vue&type=script&lang=ts&setup=true"

import "./upgrade-table.vue?vue&type=style&index=0&id=4a054802&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a054802"]])

export default __exports__